import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/3/thumb-landscape.jpg"

const Post3 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          海外セレブや芸能人がよく持っている、ゴヤール（GOYARD）のバッグは本当に人気！軽くて丈夫、そしてたくさん物を入れられることから、多くの人に愛用されています。そんなゴヤール（GOYARD）のバッグの中でも、ラクサスで多くレンタルされている人気バッグをご紹介します！あなたはどれが好きですか？
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>サンルイGM／BLACK/BROWN（黒／茶）</h2>
          <p>定番のサンルイはショッピングバッグとして最適で、男女共に人気のバッグです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/1.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/2.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/3.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">37x33x18cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>サンルイGM／ROUGE（ルージュ）</h2>
          <p>芸能人も多く愛用するサンルイ。赤のルージュカラーも人気です。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/4.jpg" alt="" />
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/5.jpg" alt="" />
        </figure>
        <span className="text-center">37x33x18cm(幅x高さxマチ)</span>      
        <div className="text-max-width">
          <h2>サンルイGM／BLUE（ブルー）</h2>
          <p>パッと目が覚めるような鮮やかなブルー。購入するには勇気がいる、こんな冒険カラーこそラクサスで挑戦してみませんか？</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/3/6.jpg" alt="" />
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/7.jpg" alt="" />
        </figure>
        <span className="text-center">37x33x18cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/goyard" className="view-all-button">
          ゴヤールのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>サンマルタン／BLACK（黒）</h2>
          <p>ゴヤールのサンマルタンは、ちょっとしたおでかけにちょうどいい大きさで、オールシーズン使えます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/8.jpg" alt="" />
          </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/10.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">33x16x9cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>サンルイPM／BLACK（黒）</h2>
          <p>たっぷりとした収納力が嬉しい♪とっても軽量で丈夫です。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/11.jpg" alt="" />
          </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/12.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/13.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">34x26x14cm(幅x高さxマチ)</span>        
        <div className="text-max-width">
          <h2>サンルイPM／BLUE MARINE（ブルーマリン）</h2>
          <p>付属のポーチはバッグの中で迷子になりがちな小物を入れるのにとっても便利♪</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/14.jpg" alt="" />
          </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/15.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/16.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">34x26x14cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/goyard" className="view-all-button">
          ゴヤールのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>マリギャラントPM／BLACK（黒）</h2>
          <p>ゴヤールのマリギャラントは普段遣いはもちろん、フォーマルなシーンでも使いやすいオススメのバッグです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/17.jpg" alt="" />
          </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/18.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/19.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">20x26x11cm(幅x高さxマチ)</span>                  
        <div className="text-max-width">
          <h2>サンルイPM／JAUNE（黄色）</h2>
          <p>イエローカラーは鮮やかな色合いで春夏の季節にぴったり！限定カラー色で今はゴヤールでも取り扱いのない激レアアイテムです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/20.jpg" alt="" />
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/21.jpg" alt="" />
        </figure>
        <span className="text-center">34x26x14cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>サンルイPM／ORANGE（オレンジ）</h2>
          <p>明るいオレンジのサンルイPMを持つだけで、いつものコーデとは違った雰囲気になれます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/22.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/23.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/24.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">34x26x14cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ベルーガPM／BLACK（黒）</h2>
          <p>サークル型のハンドルがポイントのベルーガは、A4サイズも入る使い勝手のいいサイズ感。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/25.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/26.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/27.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">24x25x10cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>サンルイPM／WHITE（ホワイト）</h2>
          <p>ホワイトはダークトーンになりがちな冬のコーデで大活躍！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/3/28.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/29.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/3/30.jpg" alt="" />
          </figure>        
        </div>
        <span className="text-center">34x26x14cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/goyard" className="view-all-button">
          ゴヤールのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post3

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 3}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
